export default "__VITE_ASSET__8e7a8653__"